import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_highlight_text_value = _resolveComponent("highlight-text-value");
  const _component_WrapWithSectionItem = _resolveComponent("WrapWithSectionItem");
  return _openBlock(), _createBlock(_component_WrapWithSectionItem, {
    selected: $props.selected,
    onSelect: _cache[0] || (_cache[0] = $event => _ctx.$emit('select', {
      id: $props.id
    })),
    onDeselect: _cache[1] || (_cache[1] = $event => _ctx.$emit('deselect', {
      id: $props.id
    })),
    onSelectOnly: _cache[2] || (_cache[2] = $event => _ctx.$emit('selectOnly', {
      id: $props.id
    }))
  }, {
    default: _withCtx(() => [_createVNode(_component_highlight_text_value, {
      class: "campaign-name",
      value: $props.name,
      query: $props.query,
      main: ""
    }, null, 8, ["value", "query"])]),
    _: 1
  }, 8, ["selected"]);
}